module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website-w540.33b0af0d.webp";